<template>
  <section id="features" class="py-16 md:py-24 bg-white">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16">
        <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-neutral-700 mb-4">
          我们的特点
        </h2>
        <p class="text-neutral-500 max-w-2xl mx-auto text-lg">
          以 “法律与技术双轮驱动” 为核心定位，为企业提供从合规保障到数字化增长的全链条解决方案。
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <!-- 特点卡片 1 -->
        <div class="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 border border-neutral-200 group">
          <div class="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors duration-300">
            <img  :src="require('@/assets/ai.png') " alt="创新思维"  class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110">
            <!--            <i class="fa fa-lightbulb-o text-primary text-2xl"></i>-->
          </div>
          <h3 class="text-xl font-bold text-neutral-700 mb-3">创新思维</h3>
          <p class="text-neutral-500">
            我们不断探索新技术和方法，通过 “咨询诊断 —方案设计 — 技术实现 — 迭代优化” 的闭环服务，帮助企业在合规框架内实现业务流程重构、运营效率提升与增长模式创新，最终完成从 “传统运营” 到 “数字原生” 的转型跨越。
          </p>
        </div>

        <!-- 特点卡片 2 -->
        <div class="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 border border-neutral-200 group">
          <div class="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors duration-300">
<!--            <i class="fa fa-cogs text-primary text-2xl"></i>-->
            <img  :src="require('@/assets/cloud.png') " alt="专业技术"  class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110">

          </div>
          <h3 class="text-xl font-bold text-neutral-700 mb-3">专业技术</h3>
          <p class="text-neutral-500">
            我们的团队由经验丰富的专业人士组成，掌握最新技术和行业趋势，能够提供高质量的技术服务。
          </p>
        </div>

        <!-- 特点卡片 3 -->
        <div class="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 border border-neutral-200 group">
          <div class="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors duration-300">
<!--            <i class="fa fa-line-chart text-primary text-2xl"></i>-->
            <img  :src="require('@/assets/data.png') " alt="专业技术"  class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110">
          </div>
          <h3 class="text-xl font-bold text-neutral-700 mb-3">数据驱动</h3>
          <p class="text-neutral-500">
            我们使用数据分析和市场研究，为客户提供基于数据的决策支持，确保解决方案的有效性和可持续性。
          </p>
        </div>

        <!-- 特点卡片 4 -->
        <div class="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 border border-neutral-200 group">
          <div class="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors duration-300">
<!--            <i class="fa fa-users text-primary text-2xl"></i>-->
            <img  :src="require('@/assets/service.png') " alt="客户至上"  class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110">
          </div>
          <h3 class="text-xl font-bold text-neutral-700 mb-3">客户至上</h3>
          <p class="text-neutral-500">
            我们始终以客户需求为中心，提供个性化的服务和支持，建立长期稳定的合作关系。
          </p>
        </div>

        <!-- 特点卡片 5 -->
        <div class="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 border border-neutral-200 group">
          <div class="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors duration-300">
<!--            <i class="fa fa-clock-o text-primary text-2xl"></i>-->
            <img  :src="require('@/assets/area.png') " alt="高效执行"  class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110">
          </div>
          <h3 class="text-xl font-bold text-neutral-700 mb-3">高效执行</h3>
          <p class="text-neutral-500">
            我们注重项目管理和执行效率，确保项目按时交付，并达到或超出客户期望。
          </p>
        </div>

        <!-- 特点卡片 6 -->
        <div class="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 border border-neutral-200 group">
          <div class="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors duration-300">
<!--            <i class="fa fa-shield text-primary text-2xl"></i>-->
            <img  :src="require('@/assets/safe1.png') " alt="安全可靠"  class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110">

          </div>
          <h3 class="text-xl font-bold text-neutral-700 mb-3">安全可靠</h3>
          <p class="text-neutral-500">
            我们重视数据安全和隐私保护，采用先进的安全技术和措施，确保客户数据和系统的安全可靠。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Features'
  }
</script>
